import Sidebar from '../components/Sidebar.jsx';
import PageHeader from '../components/PageHeader.jsx';


const Experiment = () => {
    let bgImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
    let experiments = 'https://static.igem.wiki/teams/5066/wetlab/experiment.png';

    let sections = [
        {id:'s1', name:'Experimental Overview'},
        {id:'s2', name:'Protocols'}
    ];

	return (
		<div>
            <PageHeader img={bgImg} title='Experiments' />

			<div className='flex  bg-gradient-to-b from-[#fef9e3] via-[#e8f3f7] to-[#feedfb]'>
                
                <Sidebar sections={sections}/>

				{/* Main Content */}
                <div className='flex-col w-full lg:p-[50px] p-[5px] my-[10px] space-y-16 rounded-2xl bg-white shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>

                    <div className='pb-12'>
                        <section id='s1'>
                                <div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
                                    <span className='text-gray-800 font-bold'></span>
                                </div>
                                <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                    Experimental Overview
                                </h2>
                                <img
                            src={experiments}
                            alt='softwarePic'
                            className='w-3/4 h-auto mt-4 ml-5'
                        />                        
                                <p className='ml-5 mt-4'>
                                After designing the fragments and primers, we began with the restriction enzyme digestion of the pET28a vector and amplified the fragments via overlap extension PCR. We then performed DNA assembly using NEBuilder HiFi DNA assembly. 
                                 </p>
                                 <p className='ml-5 mt-2'>
                                 The digested vectors and fragments were ligated together, and the resulting product was transformed into DH5α E. coli. The colonies were then picked and screened using colony PCR. The colony with the correct band was sent for DNA sequencing and selected for liquid culture. 
                                    
                                 </p>
                                 <p className='ml-5 mt-2'>
                                 From the liquid culture, we performed plasmid DNA extraction, after which the product was transformed into BL21(DE3) E.coli for protein expression. The resulting pellets were collected and used to conduct functional assays, including larvicidal assays, SDS-PAGE, western blotting, and real-time PCR.  
                                 </p>
                        </section>
                    </div>

                    <div className='pb-12'>
                        <section id='s2'>
                            <div className='absolute -left-24  bg-[#C94C67] w-20 h-7 shadow-md'>
                                <span className='text-gray-800 font-bold'></span>
                            </div>
                            <h2 className='text-2xl md:text-3xl font-bold text-[#C94C67] leading-relaxed'>
                                Protocols
                            </h2>
                            <p className='ml-5 mt-4'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/restriction-enzyme-digestion-of-pet28a.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Restriction Enzyme Digestion</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/overlap-extension-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Overlap Extension PCR</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/gel-electrophoresis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Gel Electrophoresis</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/gel-isolation-using-viogene-gel-pcr-isolation-system-cat-no-gp1002.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Gel Isolation using Viogene Gel/PCR Isolation System </a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/gel-isolation-using-qiaquick-gel-extraction-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Gel Isolation using QIAquick gel extraction kit</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/pcr-isolation-using-qiaquick-pcr-purification-kit.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            PCR isolation using QIAquick PCR purification kit</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/hifi-dna-assembly.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            DNA assembly</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/e-coli-competent-cells-transformation.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Transformation</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/colony-pcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Colony PCR</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/qiaprep-spin-miniprep-kit-dna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            DNA Extraction</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/serial-dilution-and-plating.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Serial Dilution</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/liquid-bacteria-culture.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Liquid Bacterial Culture</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/trial-scale-extraction-celllyticb-docx.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Trial Scale Extraction</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/large-scale-protein-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Large Scale Extraction</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/inclusion-bodies-extraction-docx.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Inclusion Body Extraction</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/bradford-protein-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Bradford Protein Assay</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/polyacrylamide-gel-electrophoresis-sds-page.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            SDS-PAGE</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/western-blot.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Western Blotting</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/rna-extraction.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            RNA Extraction</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/reverse-transcription-cdna-synthesis.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Reverse Transcription</a>
                            </p>
                            <p className='ml-5'>
                            <a href="https://static.igem.wiki/teams/5066/wetlab/real-time-pcr-qpcr.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Real-Time PCR</a>
                            </p>
                            <p className='ml-5'>
                            <a href=" https://static.igem.wiki/teams/5066/wetlab/recombinant-bacteria-growth-curve.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Growth curve of bacteria</a>
                            </p>
                            <p className='ml-5'>
                            <a href=" https://static.igem.wiki/teams/5066/wetlab/primers-used-in-dengue-beeters.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Primer list for qPCR</a>
                            </p>
                            <p className='ml-5'>
                            <a href=" https://static.igem.wiki/teams/5066/wetlab/biolarvicidal-assay.pdf" target="_blank" rel="noreferrer" className="text-pink-500 hover:text-pink-700 underline">
                            Biolarvicidal assay</a>
                            </p>
                           
                            
                            
                            
                            

                            
                        </section>
                    </div>	
			    </div>
			</div>
		</div>
	);
};

export default Experiment;